var _use, _use2, _path, _path2, _path3, _path4, _path5, _use3, _use4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_2429_419",
    fill: "#1AAB60"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_2429_419",
    fill: "#383838",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0646 47.5905C14.0646 21.307 35.3166 0 61.5323 0C119.954 18.304 105.349 87.8594 56.8543 94.9528C32.8343 92.597 14.0646 72.2914 14.0646 47.5905Z",
    fill: "#1AAB60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9269 47.5905C46.9269 51.6341 43.6573 54.9121 39.6241 54.9121C35.5909 54.9121 32.3214 51.6341 32.3214 47.5905C32.3214 43.5469 35.5909 40.2689 39.6241 40.2689C43.6573 40.2689 46.9269 43.5469 46.9269 47.5905Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.835 47.5905C68.835 51.6341 65.5655 54.9121 61.5323 54.9121C57.4991 54.9121 54.2296 51.6341 54.2296 47.5905C54.2296 43.5469 57.4991 40.2689 61.5323 40.2689C65.5655 40.2689 68.835 43.5469 68.835 47.5905Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7432 47.5905C90.7432 51.6341 87.4737 54.9121 83.4405 54.9121C79.4073 54.9121 76.1378 51.6341 76.1378 47.5905C76.1378 43.5469 79.4073 40.2689 83.4405 40.2689C87.4737 40.2689 90.7432 43.5469 90.7432 47.5905Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 82.6283C0 89.0514 2.64966 94.8557 6.91557 99.0077C7.03329 99.1222 7.10093 99.279 7.10093 99.4433V108.653C7.10093 108.807 7.2676 108.903 7.40093 108.826L15.128 104.365C15.2788 104.278 15.4598 104.261 15.625 104.316C16.2868 104.537 16.9621 104.728 17.6493 104.888C46.2446 96.5148 38.7461 63.2896 17.6493 60.3689C7.53505 62.7249 0 71.7966 0 82.6283Z",
    fill: "#42CD59"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke1_2429_419",
    fill: "#42CD59"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke1_2429_419",
    fill: "#383838",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "stroke0_2429_419",
    d: "M61.5323 0C87.748 0 109 21.307 109 47.5905C109 60.8193 103.616 72.7874 94.926 81.4127C94.4997 81.8358 94.252 82.4091 94.252 83.0105V101.234C94.252 101.798 93.6434 102.15 93.1566 101.869L77.9543 93.0689C77.4037 92.7501 76.743 92.6897 76.1379 92.8857C71.5367 94.3759 66.6283 95.181 61.5323 95.181C59.9538 95.181 58.3932 95.1038 56.8543 94.9528C105.349 87.8594 119.954 18.304 61.5323 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke1_2429_419",
    d: "M22.8548 105.483C35.4772 105.483 45.7097 95.2507 45.7097 82.6283C45.7097 70.0059 35.4772 59.7734 22.8548 59.7734C21.0641 59.7734 19.3215 59.9794 17.6493 60.3689C38.7461 63.2896 46.2446 96.5148 17.6493 104.888C19.3215 105.277 21.0641 105.483 22.8548 105.483Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.2d5f52d0f22e2f3230d9d586461c6734.svg";
export { ForwardRef as ReactComponent };